import { FC } from 'react';
import { RichTextEditor } from 'mui-tiptap';
import EditorMenuControls from './editorMenuControls';
import ButtonGeneral from '../general/buttons/buttonGeneral';
import { RichTextProps } from './props';
import useRichTextEditor from './hook';

const RichText: FC<RichTextProps> = ({
    initialContent = '<p>Escribe algo aquí...</p>',
    editable = true,
    onContentChange,
    onSave,
}) => {
    const { rteRef, content, handleUpdate, extensions, handleSave } =
        useRichTextEditor(initialContent, editable, onContentChange, onSave);

    if (!editable) {
        return (
            <div
                style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    borderRadius: '4px',
                }}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        );
    }

    return (
        <div>
            <RichTextEditor
                ref={rteRef}
                content={content}
                editable={editable}
                extensions={extensions}
                onUpdate={handleUpdate}
                renderControls={() => <EditorMenuControls />}
            />
            {onSave && (
                <ButtonGeneral
                    title="LogHTML"
                    onClick={handleSave}
                    sx={{ marginTop: '10px' }}
                />
            )}
        </div>
    );
};

export default RichText;
